import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  () => ({
    root: {},
    removeIntegrationLabel: {
      color: COLORS.error.active,
    },
  }),
  { name: 'ActionsMenu' }
);
